module.exports = __webpack_public_path__ + "static/img/036 5.373d126a.jpg";